<div style="min-width:500px;">
 <div class="modal-header"><span mat-dialog-title>Edit User</span></div>
 <div class="modal-body">
 <mat-dialog-content class="mat-typography" style="min-height:400px;">
 <form [formGroup]="researcherForm">
 <div class="row mt-3">
 <mat-form-field appearance="fill" class="w-100">
 <mat-label>Last Name</mat-label>
 <input formControlName="lastName" matInput>
 <mat-error *ngIf="researcherForm.get('lastName')?.invalid">
   {{ getErrorMessage('lastName') }}
 </mat-error>
 </mat-form-field>
 </div>

 <div class="row mt-3">
 <mat-form-field appearance="fill" class="w-100">
 <mat-label>First Name</mat-label>
 <input formControlName="firstName" matInput>
 <mat-error *ngIf="researcherForm.get('firstName')?.invalid">
   {{ getErrorMessage('firstName') }}
 </mat-error>
 </mat-form-field>
 </div>

 <div class="row mt-3">
 <mat-form-field appearance="fill" class="w-100">
 <mat-label>Email</mat-label>
 <input formControlName="email" matInput type="email">
 <mat-error *ngIf="researcherForm.get('email')?.invalid">
   {{ getErrorMessage('email') }}
 </mat-error>
 </mat-form-field>
 </div>

 <div class="row mt-3">
 <mat-form-field appearance="fill" class="w-100">
 <mat-label>Phone</mat-label>
 <input formControlName="phone"
        matInput
        appPhoneMask
        placeholder="(123) 456-7890">
 <mat-error *ngIf="researcherForm.get('phone')?.invalid">
   {{ getErrorMessage('phone') }}
 </mat-error>
 </mat-form-field>
 </div>


 <div class="row mt-3">
 <div class="col-12 pl-0">
 <label class="mb-2" style="display: block; font-weight: 500;">Roles <span class="text-danger">*</span></label>
 <div class="d-flex flex-column">
 <mat-checkbox formControlName="isResearchPersonnel" class="mb-2">Research Personnel</mat-checkbox>
 <mat-checkbox formControlName="isPrincipalInvestigator" class="mb-2">Principal Investigator</mat-checkbox>
 <mat-checkbox formControlName="isNtrIrbCoordinator" class="mb-2">NTR IRB Coordinator</mat-checkbox>
 </div>
 <mat-error *ngIf="researcherForm.errors?.rolesRequired">Please select at least one role.</mat-error>
 </div>
 </div>
 </form>
 </mat-dialog-content>
 </div>
 <mat-dialog-actions align="end">
 <button mat-stroked-button mat-dialog-close color="warn">Close</button>
 <button mat-stroked-button color="accent"
         [disabled]="researcherForm.invalid || isLoading"
         (click)="editResearcher()">Submit</button>
 </mat-dialog-actions>
</div>
